import * as React from 'react';

function SvgUkraine(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 35 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="#005BBB" d="M0 0h35v11H0z" />
      <path fill="#FFD500" d="M0 11h35v10.5H0z" />
    </svg>
  );
}

export default SvgUkraine;
